export default [{
    path: '/',
    component: () => import('./components/Page'),
    name: 'ajuda.page',
    children: [
        {path: '', name: 'ajuda.home', component: () => import('./components/Home')},
        {path: 'modulos/:module', name: 'ajuda.module.topics', component: () => import('./components/Home')},
    ]
}]
